import { TourCompletionStatus } from 'onboarding-tours-client/constants';
import { getTourStatus, setTourStatus } from 'onboarding-tours-client/onboardingToursClient';
import { useCallback, useEffect, useRef, useState } from 'react';
import { PROVIDER_MENU_TOUR_ID } from '../constants/ProviderMenu';
import { isTourInProgress } from '../utils/isTourInProgress';
import { shouldDisableOnboardingTour } from '../utils/shouldDisableOnboardingTour';
import { useComponentState } from 'navigation-components/consumer/hooks';
import { useOpenProviderMenuEvent } from './useOpenProviderMenuEvent';
export const useProviderMenuTour = ({
  setIsUserPreferencesProviderUnset,
  selectedCallProviderData
}) => {
  const isMounted = useRef(false);
  const [tourCompletionStatus, setTourCompletionStatus] = useState(null);
  const [showProviderMenu, setShowProviderMenu] = useState(false);
  const {
    isOpen
  } = useComponentState();
  useOpenProviderMenuEvent({
    setShowProviderMenu,
    showProviderMenu,
    setIsUserPreferencesProviderUnset,
    selectedCallProviderData
  });
  const endTour = status => {
    setShowProviderMenu(false);
    if (!isTourInProgress(tourCompletionStatus)) {
      return;
    }
    setTourCompletionStatus(status);
  };

  // When the remote is closed and tour is complete or skipped, we need to close the provider menu
  useEffect(() => {
    if (!isOpen && tourCompletionStatus !== TourCompletionStatus.INCOMPLETE && showProviderMenu) {
      setShowProviderMenu(false);
    }
  }, [isOpen, setShowProviderMenu, tourCompletionStatus, showProviderMenu]);
  useEffect(() => {
    switch (tourCompletionStatus) {
      case TourCompletionStatus.COMPLETE:
      case TourCompletionStatus.SKIPPED:
        setTourStatus(PROVIDER_MENU_TOUR_ID, tourCompletionStatus).catch(() => {
          // Do nothing
        });
        break;
      case TourCompletionStatus.INCOMPLETE:
        setShowProviderMenu(true);
        break;
      default:
        break;
    }
  }, [tourCompletionStatus]);
  const fetchTourStatus = useCallback(() => {
    if (shouldDisableOnboardingTour()) {
      return;
    }
    getTourStatus(PROVIDER_MENU_TOUR_ID).then(({
      status
    }) => {
      if (isMounted.current && status === TourCompletionStatus.INCOMPLETE) {
        setTourCompletionStatus(status);
      }
    }).catch(() => {
      // Do nothing
    });
  }, []);
  useEffect(() => {
    isMounted.current = true;
    fetchTourStatus();
    return () => {
      isMounted.current = false;
    };
  }, [fetchTourStatus]);
  return {
    endTour,
    setShowProviderMenu,
    showProviderMenu,
    tourCompletionStatus
  };
};